export default {"src":"https://webcdn.trailways.com/_next/static/media/info.f9d36519.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};